<dl class="wf-property-list__grid">
  @for (entry of entries(); track entry.key) {
    <dt class="wf-property-list__key wf-text-sm-medium">
      {{ entry.key | translate }}
    </dt>
    <dd class="wf-property-list__value wf-text-sm-regular">
      @switch (entry.type) {
        @case ('date') {
          {{ entry.value | date: 'dd.MM.yyyy' }}
        }
        @case ('datetime') {
          {{ entry.value | date: 'dd.MM.yyyy HH:mm' }}
        }
        @case ('number') {
          {{ entry.value | number }}
        }
        @default {
          {{ entry.value }}
        }
      }
    </dd>
  }
</dl>
